import React, { Component } from 'react'
import CloseSvg from './svg/CloseSvg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';


export class UserInfoPopUp extends Component {
    state = {
        name: "",
        surname: "",
        phone: "",
        email: "",
        error: "",
        showPopup: false
    };

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value });
    }

  render() {
    const { show, onClose } = this.props;
    const { name, surname, phone, email, error, showPopup } = this.state;

    if (!show) return null;
    return (
        <div>
            <div className="popup-bg" onClick={onClose}>
                <div
                    className="popup bg-[#fff] w-[700px] shadow  max-h-[75vh]"
                    onClick={e => e.stopPropagation()}
                >

                    <div className="bg-[#f05127] text-white p-6 rounded-t-xl flex justify-between items-center">
                        <h2 className="text-xl font-bold">Müştəri Məlumatları</h2>
                        <button className="text-white hover:text-gray-200" onClick={onClose}>
                            <CloseSvg />
                        </button>
                    </div>

                    <div
                        className="p-[20px] overflow-auto flex flex-col gap-[20px]"
                        style={{ height: "auto", maxHeight: "calc(90vh - 50px)" }}
                    >
                        <form className="p-6 space-y-4">
                            
                            {/* Ad */}
                            <div>
                                <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
                                    Ad
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        {/* <i className="fas fa-user text-gray-400"></i> */}
                                       <FontAwesomeIcon icon={faUser} className="text-gray-400" />
                                    </div>
                                    <input
                                        type="text"
                                        id="firstName"
                                        className="pl-10 w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                        placeholder="Adınızı daxil edin"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Soyad */}
                            <div>
                                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
                                    Soyad
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        {/* <i className="fas fa-user text-gray-400"></i> */}
                                       <FontAwesomeIcon icon={faUser} className="text-gray-400" />
                                    </div>
                                    <input
                                        type="text"
                                        id="lastName"
                                        className="pl-10 w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                        placeholder="Soyadınızı daxil edin"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Telefon nömrəsi */}
                            <div>
                                <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
                                    Telefon nömrəsi
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <FontAwesomeIcon icon={faPhone} className="text-gray-400" />
                                    </div>
                                    <input
                                        type="tel"
                                        id="phone"
                                        className="pl-10 w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                        placeholder="+994 XX XXX XX XX"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Email */}
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
                                    E-poçt
                                </label>
                                <div className="relative">
                                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                        <FontAwesomeIcon icon={faEnvelope} className="text-gray-400" />
                                    </div>
                                    <input
                                        type="email"
                                        id="email"
                                        className="pl-10 w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                        placeholder="email@example.com"
                                        required
                                    />
                                </div>
                            </div>

                            {/* Ünvan */}
                            <div>
                                <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1">
                                    Çatdırılma ünvanı
                                </label>
                                <div className="relative">
                                    <div className="absolute top-3 left-3 flex items-center pointer-events-none">
                                        <FontAwesomeIcon icon={faMapMarkerAlt} className="text-gray-400" />
                                    </div>
                                    <textarea
                                        id="address"
                                        rows="3"
                                        className="pl-10 w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition"
                                        placeholder="Çatdırılma ünvanınızı tam yazın"
                                        required
                                    ></textarea>
                                </div>
                            </div>

                            {/* Qeydlər */}
                            <div>
                                <label htmlFor="notes" className="block text-sm font-medium text-gray-700 mb-1">
                                    Əlavə qeydlər (istəyə bağlı)
                                </label>
                                <textarea
                                    id="notes"
                                    rows="2"
                                    className="w-full px-4 py-2 border border-[gray-300] rounded-lg 
                                            focus:border-[#f05127] focus:ring-0 transition"
                                    placeholder="Sifarişinizlə bağlı əlavə qeydlər..."
                                ></textarea>
                            </div>

                            {/* Submit */}
                            <div className="pt-4">
                                <button
                                    type="submit"
                                    className="w-full bg-[#f05127] hover:bg-[#f05127] text-white font-bold py-3 px-4 rounded-lg transition duration-200 flex items-center justify-center"
                                >
                                    <FontAwesomeIcon icon={faCheckCircle} className="mr-2" />Sifarişi Təsdiqlə
                                </button>
                            </div>
                        </form>

                        {/* ERROR MESSAGE */}
                        <div className="flex justify-center">
                            {error && (
                                <span className="text-red-500 text-[12px] mt-[4px]">
                                    {error}
                                </span>
                            )}
                        </div>

                    </div>
                </div>
            </div>
        </div>

    )
  }
}

export default UserInfoPopUp
